// 細分化画像のレコード情報の閲覧・編集を行う。人判断のスコアを修正、保存
// base lib
import * as React from 'react';
import { Dispatch, Action } from 'redux';
import { connect } from 'react-redux';
import * as H from 'history';
import ReactToPrint from 'react-to-print'; // 印刷ダイアログを表示する
import * as moment from 'moment';
// 画像切り取りライブラリ
import 'cropperjs/dist/cropper.css';
// material-ui
import { Typography, Paper, Button } from '@material-ui/core';
import CloudUpload from '@material-ui/icons/CloudUpload';
import DeleteForever from '@material-ui/icons/DeleteForever';
import Print from '@material-ui/icons/Print';
// redux
import { IAppState, kansatsuKirokuSubdivOperations } from '../../redux/modules';
import { SiteInfoListSubdivState } from '../../redux/modules/siteInfoListSubdiv';
import { KansatsuKirokuSubdivState } from '../../redux/modules/kansatsuKirokuSubdiv';
// model
import { SiteInfo } from '../../models/SiteInfo';
import { KansatsuKirokuSubdiv } from '../../models/KansatsuKirokuSubdiv';


import { InferenceResultSubdiv } from '../../models/InferenceResultSubdiv';
import { InferenceAdditionalResultSubdiv } from '../../models/InferenceAdditionalResultSubdiv';

// other components
import { PrintKansatsuKirokuSubdiv } from './PrintKansatsuKirokuSubdiv'; // 印刷用画面
// eslint-disable-next-line @typescript-eslint/no-unused-vars
import { CloseBackButton } from '../parts/CloseBackButton'; // 戻るボタン
// import { InferenceResultSubdivView } from '../parts/InferenceResultSubdivView';  // 総合評価表の表示
import KansatsuKirokuEdit from '../parts/KansatsuKirokuEdit'; // 観察記録のテキスト入力エリア
import KansatsuKirokuScoreEditForSubdiv, { DEFAULT_ROCK_MASS_GROUP_ID } from '../parts/KansatsuKirokuScoreEditForSubdiv'; // 総合評価表の表示 観察記録のスコア入力エリア

const styles = {
  contentBase: {
    padding: '20px',
    marginBottom: '20px'
  }
};

interface OwnProps {
  // ページ情報
  match: any; // withRouterにより設定される
  sites: SiteInfoListSubdivState;
  history: H.History;
  // 関数
  clear: () => void; // このページでは利用しない
  reset: () => any; // KansatsuKirokuSubdivStateを初期状態に戻す
  getRecord: ({ koujiBangou, key, completeHandler }
      :{ koujiBangou: string, key: string, completeHandler: () => any }) => any; // 該当レコードの情報を取得する
  postRecord: (record: KansatsuKirokuSubdiv, completeHandler: () => any) => any; // 該当レコードを保存する
  fetchLatestRockMassGroup: ({ koujiBangou }: { koujiBangou: string }) => any; // 最新岩石グループ取得アクションを追加
  // 変数
  kansatsuKirokuSubdiv: KansatsuKirokuSubdivState;
  latestRockMassGroup?: string; // Reduxから最新の岩石グループを取得
}

interface OwnState {
  site: SiteInfo | undefined; // 工事現場の情報

  lineNum: number;                   // 細分化 行サイズ
  columnNum: number;                 // 細分化 列サイズ
  observationNames: string[];        // 観察項目名
  observationDescriptions: string[]; // 観察項目_説明
  kansatsuKirokuObsrecScoreEditElementElementState: { // 人判断の観察項目情報 「KansatsuKirokuObsrec['observationsScores']」と同じ型 印刷のために利用
    observationsScores: Array<{
      observation: string; // 観察項目
      scores: Array<{
        position: string; // 位置（左上から右方向でカウントしたときの位置）
        score: string; // スコア
      }>;
    }>,
    resultHuman: InferenceResultSubdiv[]; // 人判断のresult(人判断の総合評価用)
    additionalResultHuman: InferenceAdditionalResultSubdiv; // 人判断のadditionalResult(人判断の総合評価用)
    selectedRockMassGroup?: string;
  },
  // 親コンポーネントで選択された岩石グループを保持する
  selectedRockMassGroup: string; // 型を string に変更 (undefined ではなくデフォルト値を持つため)
};

class EditKansatsuKirokuSubdivPage extends React.Component<OwnProps, OwnState>{
  private kansatsuKirokuSubdivEditElement: KansatsuKirokuEdit;
  private kansatsuKirokuObsrecScoreEditElement: KansatsuKirokuScoreEditForSubdiv;
  // 印刷対象Elementへの参照
  private printTargetRef;
  constructor(props: OwnProps) {
    super(props);
    this.state = {
      site: new SiteInfo(),
      lineNum: 0,
      columnNum: 0,
      observationNames: [],
      observationDescriptions: [],
      kansatsuKirokuObsrecScoreEditElementElementState: {
        observationsScores:[],
        resultHuman:[],
        additionalResultHuman:{ // 印刷のために利用
          each_position_score: { // 左肩・天端・右肩のスコア
              left: 0,
              top: 0,
              right: 0,
          },
          each_position_weight: { // 左肩・天端・右肩の重み
              left: 0,
              top: 0,
              right: 0,
          },
          finally_score: 0, // 最終評価点
        },
          selectedRockMassGroup: undefined
      },
      // 初期値はデフォルトIDに設定
      selectedRockMassGroup: DEFAULT_ROCK_MASS_GROUP_ID
    }
    // getRecord完了ハンドラをbind
    this.handleRecordLoaded = this.handleRecordLoaded.bind(this);
  }

  componentDidMount() {
    // このページの工事番号
    const koujiBangou = this.props.match.params.koujibangou;
    const key = this.props.match.params.key;
    const isNewRecord = !key;

    // このページの工事情報
    const siteInfo = this.props.sites.items.find((item) => (item.koujiBangou === koujiBangou));
    // 工事情報が不正な場合はリストに戻る
    if (!siteInfo) {
      this.props.history.replace('/subdiv/sitelist');
      return ;
    }

    // --- SiteInfoから必要な情報を取得 ---
    const lineNumInfo = siteInfo.lineNum; // 細分化行数
    const columnNumInfo = siteInfo.columnNum; // 細分化列数
    const observationNamesInfo = siteInfo.observationNames || []; // 観察項目の名称 リスト (nullチェック追加)
    const observationDescriptionsInfo = siteInfo.observationDescriptions || []; // 観察項目の説明 リスト (nullチェック追加)
    // --- ここまで ---

    this.setState({
      site: siteInfo,
      lineNum: lineNumInfo,
      columnNum: columnNumInfo,
      observationNames: observationNamesInfo,
      observationDescriptions: observationDescriptionsInfo
      // selectedRockMassGroup はここではまだ設定しない
    });

    if (isNewRecord) {
      // 新規作成の場合
      this.props.reset(); // item を初期化
      this.props.fetchLatestRockMassGroup({ koujiBangou }); // 短縮形に修正
      // 初期値は constructor で DEFAULT_ROCK_MASS_GROUP_ID に設定済み
      // 最新グループが取得されたら componentDidUpdate で更新
    } else {
      // 編集の場合
      this.props.getRecord({
        koujiBangou, // 短縮形に修正
        key, // 短縮形に修正
        completeHandler: this.handleRecordLoaded // 完了ハンドラを渡す
      });
    }
  }

  // 編集時のレコード読み込み完了ハンドラ
  handleRecordLoaded() {
    const initialScoreData = this.kansatsuKirokuObsrecScoreEditElement && this.kansatsuKirokuObsrecScoreEditElement.get();
    const loadedRockMassGroup = this.props.kansatsuKirokuSubdiv.item.rockMassGroup;

    // 編集時は既存レコードの値を優先、なければデフォルト
    const rockGroupToSet = loadedRockMassGroup || DEFAULT_ROCK_MASS_GROUP_ID;

    this.setState({
      selectedRockMassGroup: rockGroupToSet
    });

    // 印刷に使用する state も更新する
    if (initialScoreData) {
      this.setState(prevState => ({
        kansatsuKirokuObsrecScoreEditElementElementState: {
          ...prevState.kansatsuKirokuObsrecScoreEditElementElementState,
          observationsScores: initialScoreData.observationsScores || [],
          resultHuman: initialScoreData.resultHuman || [],
          additionalResultHuman: initialScoreData.additionalResultHuman || { /* デフォルトオブジェクト */ },
          selectedRockMassGroup: rockGroupToSet // 印刷用 state にも反映
        }
      }));
    } else if (rockGroupToSet !== undefined) {
         this.setState(prevState => ({
            kansatsuKirokuObsrecScoreEditElementElementState: {
              ...prevState.kansatsuKirokuObsrecScoreEditElementElementState,
              selectedRockMassGroup: rockGroupToSet
            }
         }));
    }
  }

  componentDidUpdate(prevProps: OwnProps) {
    const key = this.props.match.params.key;
    const isNewRecord = !key;

    // 新規作成時 かつ latestRockMassGroup が更新された場合
    if (isNewRecord && this.props.latestRockMassGroup !== prevProps.latestRockMassGroup && this.props.latestRockMassGroup) {
      const rockGroupToSet = this.props.latestRockMassGroup;
      this.setState({ selectedRockMassGroup: rockGroupToSet });

      // 印刷用 state も更新 (スコアデータはまだないので岩石グループのみ)
      this.setState(prevState => ({
        kansatsuKirokuObsrecScoreEditElementElementState: {
          ...prevState.kansatsuKirokuObsrecScoreEditElementElementState,
          selectedRockMassGroup: rockGroupToSet
        }
      }));
    }
  }

  componentWillUnmount() {
    this.props.reset();
  }

  // 子コンポーネントからの岩石グループ変更を受け取るハンドラ
  handleRockMassGroupChange = (group: string) => {
    this.setState({ selectedRockMassGroup: group });
    // 印刷用stateも更新しておく
    this.setState(prevState => ({
        kansatsuKirokuObsrecScoreEditElementElementState: {
            ...prevState.kansatsuKirokuObsrecScoreEditElementElementState,
            selectedRockMassGroup: group
        }
    }));
  };

  getKansatsuKirokuObsrecScoreEditElementElementState() {
    const kansatsuKirokuObsrecScoreEditElementData = this.kansatsuKirokuObsrecScoreEditElement.get(); // 人判断の評価値を取得
    this.setState({
        kansatsuKirokuObsrecScoreEditElementElementState : JSON.parse(JSON.stringify(kansatsuKirokuObsrecScoreEditElementData))
    })
  }

  /**
   * データを登録する
   */
  register() {
    const record = { ...this.props.kansatsuKirokuSubdiv.item };

    const kansatsuKirokuSubdivEditData = this.kansatsuKirokuSubdivEditElement.get(); // 手動で入力する観察記録の属性値を取得
    const currentObservationsScores = this.kansatsuKirokuObsrecScoreEditElement.get().observationsScores;
    const currentAdditionalResultHuman = this.kansatsuKirokuObsrecScoreEditElement.get().additionalResultHuman;

    record.kansatsuDate = kansatsuKirokuSubdivEditData.kansatsuDate;                    // 観察記録の属性値:観察年月日
    record.sokutenNumber = kansatsuKirokuSubdivEditData.sokutenNumber;                  // 観察記録の属性値:測点No.
    record.danmenNumber = kansatsuKirokuSubdivEditData.danmenNumber;                    // 観察記録の属性値:断面番号
    record.kyori = kansatsuKirokuSubdivEditData.kyori;                                  // 観察記録の属性値:坑口からの距離[m]
    record.kansatsuDateMemo = kansatsuKirokuSubdivEditData.kansatsuDateMemo;            // 観察記録の属性値:観察年月日:備考
    record.sokutenNumberMemo = kansatsuKirokuSubdivEditData.sokutenNumberMemo;          // 観察記録の属性値 測点No.:備考
    record.danmenNumberMemo = kansatsuKirokuSubdivEditData.danmenNumberMemo;            // 観察記録の属性値:断面番号:備考
    record.kyoriMemo = kansatsuKirokuSubdivEditData.kyoriMemo;                          // 観察記録の属性値:坑口からの距離[m]:備考
    record.freeInputs = kansatsuKirokuSubdivEditData.freeInputs;                        // 観察記録の属性値:自由記入欄
    record.freeInputsJsonStr = JSON.stringify(kansatsuKirokuSubdivEditData.freeInputs); // 観察記録の属性値:自由記入欄 JSON形式（またはJSONリスト）を保持するときは文字列で格納する
    record.inferenceResultSubdivJsonStr = JSON.stringify(record.inferenceResultSubdiv); // 推論結果情報 JSON形式（またはJSONリスト）を保持するときは文字列で格納する
    record.inferenceAdditionalResultSubdivJsonStr = JSON.stringify(record.inferenceAdditionalResultSubdiv); // AI判断 総合評価点情報
    record.observationsScoresOrgJsonStr = JSON.stringify(record.observationsScoresOrg);  // AI推論結果のオリジナル情報 JSON形式（またはJSONリスト）を保持するときは文字列で格納する
    record.observationsScoresJsonStr = JSON.stringify(currentObservationsScores); // 手動スコアリングの情報 JSON形式（またはJSONリスト）を保持するときは文字列で格納する
    record.inferenceAdditionalResultHumanSubdivJsonStr = JSON.stringify(currentAdditionalResultHuman); // 人判断 総合評価点情報
    // --- RockMassGroupを追加 ---
    // selectedRockMassGroup state から値を取得して設定
    record.rockMassGroup = this.state.selectedRockMassGroup;
    // --- ここまで ---

    record.lastModifiedAt = moment().format(); // このページでは修正のみなのでlastModifiedAtのみ設定

    this.props.postRecord(record, () => {
      // @ts-ignore
    });
  }
  /**
   * データを削除する
   * ここでの削除は論理削除なので、deletedAtに日時を指定してpostする
   */
  delete() {
    if (!confirm('観察記録を削除しますか？')) {
      return;
    }
    // 削除するレコード
    const record = { ...this.props.kansatsuKirokuSubdiv.item };

    const kansatsuKirokuSubdivEditData = this.kansatsuKirokuSubdivEditElement.get();    // 手動で入力する観察記録の属性値を取得
    // const kansatsuKirokuObsrecScoreEditElementData = this.kansatsuKirokuObsrecScoreEditElement.get(); // スコアと岩石グループを取得
    const currentObservationsScores = this.kansatsuKirokuObsrecScoreEditElement.get().observationsScores;
    const currentAdditionalResultHuman = this.kansatsuKirokuObsrecScoreEditElement.get().additionalResultHuman;
    record.kansatsuDate = kansatsuKirokuSubdivEditData.kansatsuDate;                    // 観察記録の属性値:観察年月日
    record.sokutenNumber = kansatsuKirokuSubdivEditData.sokutenNumber;                  // 観察記録の属性値:測点No.
    record.danmenNumber = kansatsuKirokuSubdivEditData.danmenNumber;                    // 観察記録の属性値:断面番号
    record.kyori = kansatsuKirokuSubdivEditData.kyori;                                  // 観察記録の属性値:坑口からの距離[m]
    record.kansatsuDateMemo = kansatsuKirokuSubdivEditData.kansatsuDateMemo;            // 観察記録の属性値:観察年月日:備考
    record.sokutenNumberMemo = kansatsuKirokuSubdivEditData.sokutenNumberMemo;          // 観察記録の属性値 測点No.:備考
    record.danmenNumberMemo = kansatsuKirokuSubdivEditData.danmenNumberMemo;            // 観察記録の属性値:断面番号:備考
    record.kyoriMemo = kansatsuKirokuSubdivEditData.kyoriMemo;                          // 観察記録の属性値:坑口からの距離[m]:備考
    record.freeInputs = kansatsuKirokuSubdivEditData.freeInputs;                        // 観察記録の属性値:自由記入欄
    record.freeInputsJsonStr = JSON.stringify(kansatsuKirokuSubdivEditData.freeInputs); // 観察記録の属性値:自由記入欄 JSON形式（またはJSONリスト）を保持するときは文字列で格納する
    record.inferenceResultSubdivJsonStr = JSON.stringify(record.inferenceResultSubdiv); // 推論結果情報 JSON形式（またはJSONリスト）を保持するときは文字列で格納する
    record.inferenceAdditionalResultSubdivJsonStr = JSON.stringify(record.inferenceAdditionalResultSubdiv); // 総合評価点情報

    record.observationsScoresOrgJsonStr = JSON.stringify(record.observationsScoresOrg);  // AI推論結果のオリジナル情報 JSON形式（またはJSONリスト）を保持するときは文字列で格納する
    record.observationsScoresJsonStr = JSON.stringify(currentObservationsScores); // 手動スコアリングの情報 JSON形式（またはJSONリスト）を保持するときは文字列で格納する
    record.inferenceAdditionalResultHumanSubdivJsonStr = JSON.stringify(currentAdditionalResultHuman); // 人判断 総合評価点情報
    // --- RockMassGroupを追加 ---
    // selectedRockMassGroup state から値を取得して設定
    record.rockMassGroup = this.state.selectedRockMassGroup;
    // --- ここまで ---

    record.deletedAt = moment().format(); // 削除時刻のみ設定

    this.props.postRecord(record, () => {
      // @ts-ignore
    });
  }

  render() {
    const site = this.state.site || new SiteInfo();
    const isDeleted = this.props.kansatsuKirokuSubdiv.item.deletedAt ? true: false;
    // console.log("EditKansatsuKirokuSubdivPage をレンダリング中 selectedRockMassGroup state:", this.state.selectedRockMassGroup);
    return (
    <div>
      <Paper style={{ padding: '10px' }}>
        <Typography variant="h4" style={{ marginBottom: '10px' }}>
          {site.koujiBangou} : {site.name}
        </Typography>
        <div className="command-area">
          <div className="command-area-left">
            <Typography variant="h6">[細分化画像]-観察記録 { isDeleted ? '　（削除済み） ' : ''}</Typography>
            {/* <CloseBackButton history={this.props.history} /> */}
          </div>
          <div className="command-area-right">
            <Typography variant="body2" style={{ color: 'rgba(0,0,0,0.54)', textAlign: 'right' }}>
              作成 {this.props.kansatsuKirokuSubdiv.item.createdAt ? moment(this.props.kansatsuKirokuSubdiv.item.createdAt).format('MM/DD HH:mm') : '-'}<br/>
              更新 {this.props.kansatsuKirokuSubdiv.item.lastModifiedAt ? moment(this.props.kansatsuKirokuSubdiv.item.lastModifiedAt).format('MM/DD HH:mm') : '-'}
            </Typography>
          </div>
        </div>
        <Paper
          style={styles.contentBase}
        >
          <KansatsuKirokuEdit
            disabled={isDeleted}
            data={this.props.kansatsuKirokuSubdiv.item}
            ref={(r) => {
              if (r) {
                this.kansatsuKirokuSubdivEditElement = r;
              }
            }}
          />
          {/* <Button
            variant="contained"
            color="secondary"
            fullWidth
            onClick={() => this.register()}
            disabled={isDeleted}
          >
            <CloudUpload style={{ marginRight: '5px'}}/>
            観察記録を保存
          </Button> */}
        </Paper>

        <Typography variant="h6">診断画像</Typography>
        <Paper
          style={styles.contentBase}
        >
          {
            (this.props.kansatsuKirokuSubdiv.item.croppedImageSignedUrl)
              ? <img src={this.props.kansatsuKirokuSubdiv.item.croppedImageSignedUrl} />
              : <div>診断画像なし</div>

          }
        </Paper>

        <Typography variant="h6">診断結果</Typography>
        {/* <Paper
          style={styles.contentBase}
        >
          {
            this.props.kansatsuKirokuSubdiv.item.inferenceResultSubdiv
              ? <InferenceResultSubdivView
                  result={this.props.kansatsuKirokuSubdiv.item.inferenceResultSubdiv}
                  additionalResult={this.props.kansatsuKirokuSubdiv.item.inferenceAdditionalResultSubdiv}
                />
              : <div>診断結果なし</div>

          }
        </Paper> */}
        <Paper
          style={styles.contentBase}
        >
        <KansatsuKirokuScoreEditForSubdiv
                disabled={isDeleted}
                data={this.props.kansatsuKirokuSubdiv.item.observationsScores}
                // state の値を直接子コンポーネントに渡す
                rockMassGroup={this.state.selectedRockMassGroup} // state の値を渡す
                lineNum={this.state.lineNum}
                columnNum={this.state.columnNum}
                observationNames={this.state.observationNames}
                observationDescriptions={this.state.observationDescriptions}

                result={this.props.kansatsuKirokuSubdiv.item.inferenceResultSubdiv}
                additionalResult={this.props.kansatsuKirokuSubdiv.item.inferenceAdditionalResultSubdiv}
                cropImageWidth={site.cropImageWidth}
                orgdata={this.props.kansatsuKirokuSubdiv.item.observationsScoresOrg}

                // 評価値確定がステップルールの場合に必要な要素
                targetStepRuleObservationNames={site.targetStepRuleObservationNames}
                // 評価値確定が最頻値ルールの場合に必要な要素
                targetModeRuleObservationNames={site.targetModeRuleObservationNames}
                // 評価値確定が平均<スコア重複排除前提>ルールの場合に必要な要素
                targetMeanDeduplicationRuleObservationNames={site.targetMeanDeduplicationRuleObservationNames}
                // 評価値確定が平均<一般>ルールの場合に必要な要素
                targetMeanGeneralRuleObservationNames={site.targetMeanGeneralRuleObservationNames}
                topBadsideSize={site.topBadsideSize}
                leftBadsideSize={site.leftBadsideSize}
                rightBadsideSize={site.rightBadsideSize}

                // --- 切羽評価点テーブル用のPropsを追加 ---
                excavationFaceScoreConversionTableData={site.excavationFaceScoreConversionTableData}
                observationMap={site.observationMap}
                isIncludeInSubtotalObservations={site.isIncludeInSubtotalObservations}
                isIncludeInTotalObservations={site.isIncludeInTotalObservations}
                // --- ここまで ---

                // 岩石グループ変更ハンドラを渡す
                onRockMassGroupChanged={this.handleRockMassGroupChange}

                ref={(r) => {
                  if (r) {
                    this.kansatsuKirokuObsrecScoreEditElement = r;
                  }
                }}
        />
        </Paper>

        <div style={{margin: '10px 10px'}}>
          <Button
              variant="contained"
              color="secondary"
              fullWidth
              onClick={() => this.register()}
              disabled={isDeleted}
            >
              <CloudUpload style={{ marginRight: '5px'}}/>
              観察記録を保存
            </Button>
        </div>

        {/* --- 下部のボタンエリアを画像のレイアウトに合わせる --- */}
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-end', padding: '10px 10px' }}>
          {/* 左側のボタン群 (印刷、戻るを縦に配置) */}
          <div style={{ display: 'flex', flexDirection: 'column', width: '90px' }}>
            <ReactToPrint
              // @ts-ignore
              trigger={() => {
                return (
                  <Button
                    variant="contained"
                    style={{ width: '100%' }}
                  >
                    <Print style={{ marginRight: '5px'}}/>
                    印刷
                  </Button>
                );
              }}
              content={() => {
                // 印刷前に最新のスコア情報を取得する
                const latestScores = this.kansatsuKirokuObsrecScoreEditElement.get();
                // stateを更新する（selectedRockMassGroup は別で更新済み）
                this.setState(prevState => ({
                    kansatsuKirokuObsrecScoreEditElementElementState: {
                        ...prevState.kansatsuKirokuObsrecScoreEditElementElementState,
                        observationsScores: latestScores.observationsScores,
                        resultHuman: latestScores.resultHuman,
                        additionalResultHuman: latestScores.additionalResultHuman,
                    }
                }));
                // stateの更新を待たずに参照を返す（PrintKansatsuKirokuSubdivのrenderが更新されたstateを見るはず）
                return this.printTargetRef;
              }}
              // 印刷のタイトル、環境によってはPDF保存時のファイル名のデフォルトになる
              documentTitle="観察簿"
            />
            {/* 印刷ボタンと戻るボタンの間にスペースを追加 */}
            <div style={{ height: '10px' }} />
            <div style={{ width: '100%' }}> {/* 戻るボタンを包むコンテナ */}
              <CloseBackButton history={this.props.history} />
            </div>
          </div>

          {/* 右側のボタン (削除) */}
          <Button
            variant="contained"
            color="secondary"
            onClick={() => this.delete()}
            disabled={isDeleted}
            style={{ width: 'auto', minWidth: '162px' }}
          >
            <DeleteForever style={{ marginRight: '5px'}}/>
            観察記録を削除
          </Button>
        </div>
        {/* --- ここまで修正 --- */}
      </Paper>
      {/* データ印刷領域 */}
      <div
        style={{
          display: 'none'
        }}
      >
        <div ref={(el) => this.printTargetRef = el}>
          <PrintKansatsuKirokuSubdiv
            siteInfo={site}
            kansatsuKiroku={this.props.kansatsuKirokuSubdiv.item}
            // 印刷用コンポーネントには最新の state と siteInfo 由来のデータを結合して渡す
            KansatsuKirokuObsrecScore={ {
               ...this.state.kansatsuKirokuObsrecScoreEditElementElementState, // スコア、人判断結果、岩石グループID
               // siteInfo由来のデータを追加
               excavationFaceScoreConversionTableData: site.excavationFaceScoreConversionTableData,
               observationMap: site.observationMap,
               isIncludeInSubtotalObservations: site.isIncludeInSubtotalObservations,
               isIncludeInTotalObservations: site.isIncludeInTotalObservations,
            } }
          />
        </div>
      </div>

    </div>
    );
  }
}

function mapDispatchToProps(dispatch: Dispatch<Action<any>>) {
  return {
    getRecord: ({ koujiBangou, key, completeHandler }) => {
      kansatsuKirokuSubdivOperations.get({ koujiBangou, key })(dispatch)
        .then(() => completeHandler());
    },
    postRecord: (record, completeHandler) => {
      kansatsuKirokuSubdivOperations.post(record)(dispatch)
        .then(() => completeHandler());
    },
    reset: () => {
      kansatsuKirokuSubdivOperations.resetRecord()(dispatch);
    },
    // fetchLatestRockMassGroup を dispatch する関数を追加
    fetchLatestRockMassGroup: ({ koujiBangou }) => {
      kansatsuKirokuSubdivOperations.fetchLatestRockMassGroup({ koujiBangou })(dispatch);
    }
  };
}

function mapStateToProps(appState: IAppState) {
  return {
    user: appState.user,
    sites: appState.siteInfoListSubdiv,
    kansatsuKirokuSubdiv: appState.kansatsuKirokuSubdiv,
    // Redux State から latestRockMassGroup を取得
    latestRockMassGroup: appState.kansatsuKirokuSubdiv.latestRockMassGroup
  };
}
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(EditKansatsuKirokuSubdivPage);



// WEBPACK FOOTER //
// ./src/components/subdiv/EditKansatsuKirokuSubdivPage.tsx